<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="!!this.clientId">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div v-show="inn && !!clientId">
          <b>Компания использует Систему "АТЛАНТ-СМАРТ" </b>
        </div>
        <div v-show="inn && !clientId">
          <b>Компания пока не использует Систему "АТЛАНТ-СМАРТ".</b>
        </div>
      </div>
      </v-panel-title>
      <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show="!isLoading">
        <v-client-preview :clientProfile="item"></v-client-preview>
      </div>  
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'
  import vClientPreview from '../client/ClientPreview'

  export default {
    name: 'v-client-preview-panel',
    components: {vPanelTitle, vClientPreview},
    data: () => ({
      id: null,
      item: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      inn: {
        type: Number,
        default: null
      },
      clientId: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.item = this.getItemNew()
      this.id = this.inn
    },
    watch: {
      inn: function (newVal, oldVal) { // watch it
        this.id = this.inn
      }
    },
    computed: {
      ...mapGetters({
      })
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && (!this.item.inn || this.item.inn.length === 0)) {
          this.fetchItems()
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о клиенте для компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/client',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.item = this.getItemNew()
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.isLoading = false
            this.item = data
          })
        }
      },
      getItemNew () {
        return {
          inn: '',
          email: '',
          nameShort: '',
          address: '',
          phone: '',
          website: '',
          notes: '',
          about: '',
          contacts: '',
          services: '',
          price: '',
          docs: '',
          tags: '',
          other: ''
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// ClientPreviewPanel.vue?b70e87c2